import React, {useState} from 'react';
import {v4 as uuidv4} from 'uuid';
import "./styleKpiFull.css"
import {HandySvg} from "handy-svg";
import dataFalse from "../statusBar/img/data_false.svg";
import dataTrue from "../statusBar/img/data_true.svg";
import arrowUpDownKpiFull from "../kpiFull/icon/UpDownArrowFullKpi.svg";
import DataUndefaind from "../../DataUndifaend/DataUndefaind";

function KpiFull({ kpi_data, onKpiNameChange,onKystIdChange ,expandedKpiDetails, expandedKystDetails,  role }) {

    const sendKpiNameIdToParent = (id) => {
        onKpiNameChange(id);
    };

    const sendKystIdToParent = (id) => {
        onKystIdChange(id);
    };

    function purposeId (){
        return uuidv4()
    }

    let mainColor = 'red';

    const [full, setFull] = useState([]);
    const [fullLevel2, setFullLevel2] = useState([]);
    const [isRotated, setIsRotated] = useState([]);
    const [isRotatedLevel2, setIsRotatedLevel2] = useState([]);

    function getId(idOpenFull, id){

        sendKpiNameIdToParent(id);

        setFull((prev) => ({
            ...prev,
            [idOpenFull]: !prev[idOpenFull],
        }));

        setIsRotated((prev) => ({
            ...prev,
            [idOpenFull]: !prev[idOpenFull],
        }));
    }

    function getIdKust(id){

        sendKystIdToParent(id);

        setFullLevel2((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));

        setIsRotatedLevel2((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));

    }

    function getKpiContainerClassColor (details){

        const mainDetail = details.find(detail => detail.is_main === true);

        if (!mainDetail) return undefined;

        if (mainDetail.zone === "green") {
            return "green__full";
        } else if (mainDetail.zone === "yellow") {
            return "orange__full";
        } else {
            return "red__full";
        }
    }

    function getSmilesColor(details) {
        const mainDetail = details.find(detail => detail.is_main === true);

        if (!mainDetail) return undefined;

        if (mainDetail.zone === "green") {
            return "green--smile";
        } else if (mainDetail.zone === "yellow") {
            return "orange--smile";
        } else {
            return "red--smile";
        }
    }

    function ColorZone (zone){
        if (zone === "green"){
            return "green--value"
        }else if(zone === "yellow"){
            return "orange--value"
        }else{
            return "red--value"
        }
    }

    if (kpi_data && kpi_data.details && kpi_data.details.length > 0) {
        for (let i = 0; i < kpi_data.details.length; i++) {
            if (kpi_data.details[i].is_main) {
                mainColor = kpi_data.details[i].zone;
                break;
            }
        }
    }

    function setValue(value__, is_percents__) {
        if (is_percents__) {
            return (value__ * 100).toFixed(1) + "%";
        } else {
            const num = parseFloat(value__);
            return num === Math.floor(num) ? num.toString() : num.toString().replace(/\.?0+$/, '');
        }
    }


    if (kpi_data !== undefined) {
        return (
            <div className={"kpi__full__wrapper"}>
                {(role === "Админ" || role === "Руководитель") ? (
                    kpi_data.map((kpi) => {
                        const id = kpi.name;
                        return (
                            <div key={purposeId()} id={purposeId()} className={`kpi__full__conteiner ${getKpiContainerClassColor(kpi.details)}`}>
                                <div className={"kpi__full__conteiner__title"}>
                                    <h2 className={"kpi__full__conteiner__title__name"}>{kpi.name}</h2>
                                    <div className={"kpi__full__conteiner__title__wrapper__actual__date"} key={purposeId()} id={purposeId()}>
                                        <div className={`Smile__full__kpi ${getSmilesColor(kpi.details)}`}></div>
                                        <HandySvg
                                            src={arrowUpDownKpiFull}
                                            id={kpi.id}
                                            className={`kpi__full__conteiner__title__arrow rotate ${isRotated[id] ? "activefull" : ""}`}
                                            onClick={() => getId(id, kpi.id)}
                                        />
                                    </div>
                                </div>
                                <div className={`aggregated__wrapper`}>
                                    {!full[id] &&
                                        kpi.details.map((agrDetails) => (
                                            <div key={purposeId()} className={`aggregated__wrapper__item`}>
                                                <span className="kpi__full__conteiner__data__item__name aggregated__wrapper__item__name">
                                                  {agrDetails.name}:
                                                </span>
                                                <span className={`kpi__full__conteiner__data__item__name__date ${ColorZone(agrDetails.zone)}`}>
                                                  {agrDetails.value === null ? "Нет" : setValue(agrDetails.value, agrDetails.is_percents)}
                                                </span>
                                            </div>
                                        ))}
                                </div>
                                {full[id] && (
                                    expandedKpiDetails.filter((KystData) => KystData._id === kpi.id).map((KystData) => (
                                        <div key={purposeId()} className={"kpi__full__conteiner__liner kpi__full__conteiner__liner__adminModifikator"}>
                                            <div className={"kyst__kpi__full"}>
                                                <h3 id={KystData.id} className={"kpi__full__conteiner__liner__shopName"}>{KystData.name}</h3>
                                                <div className="kpi__full__conteiner__data__item__is_actual" style={{opacity: 0}}>
                                                    <span>Актуально:</span>
                                                    <HandySvg
                                                        src={KystData.is_actual ? dataTrue : dataFalse}
                                                        className={KystData.is_actual ? "svg--data_true" : "svg--data_false"}
                                                    />
                                                </div>
                                                {KystData.details.length > 0 ? (
                                                    <div className="kpi__full__conteiner__data">
                                                        {KystData.details.map((detail) => (
                                                            <div key={purposeId()} className="kpi__full__conteiner__data__item kpi__full__conteiner__data__item-modificator">
                                                                <span className="kpi__full__conteiner__data__item__name kpi__full__conteiner__data__item__name-modificator">{detail.name}:</span>
                                                                <span className={`kpi__full__conteiner__data__item__name__date ${ColorZone(detail.zone)}`}>
                                                                  {detail.value === null ? "Нет" : setValue(detail.value, detail.is_percents)}
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <p>Нет данных</p>
                                                )}
                                                <HandySvg
                                                    src={arrowUpDownKpiFull}
                                                    id={KystData.id}
                                                    className={`kpi__full__conteiner__title__arrow rotate ${isRotatedLevel2[KystData.id] ? "activefull" : ""}`}
                                                    onClick={() => getIdKust(KystData.id)}
                                                />
                                            </div>
                                            {fullLevel2[KystData.id] && (
                                                <div className={"kpi__kyst_full"}>
                                                    {expandedKystDetails
                                                        .filter((shoData) => shoData._id === KystData.id)
                                                        .map((shoData) => (
                                                            <div key={purposeId()} className={"kpi__full__conteiner__liner admin__shops__modificator"}>
                                                                <h3 id={shoData.id} className={"kpi__full__conteiner__liner__shopName"}>
                                                                    {shoData.name}
                                                                </h3>
                                                                <div className="kpi__full__conteiner__data__item__is_actual">
                                                                    <span>Актуально:</span>
                                                                    <HandySvg
                                                                        src={shoData.is_actual ? dataTrue : dataFalse}
                                                                        className={shoData.is_actual ? "svg--data_true" : "svg--data_false"}
                                                                    />
                                                                </div>
                                                                {shoData.details.length > 0 ? (
                                                                    <div className="kpi__full__conteiner__data">
                                                                        {shoData.details.map((detail) => (
                                                                            <div key={purposeId()} className="kpi__full__conteiner__data__item kpi__full__conteiner__data__item-modificator">
                                                                                <span className="kpi__full__conteiner__data__item__name kpi__full__conteiner__data__item__name-modificator">{detail.name}:</span>
                                                                                <span className={`kpi__full__conteiner__data__item__name__date ${ColorZone(detail.zone)}`}>
                                                                                    {detail.value === null ? "Нет" : setValue(detail.value, detail.is_percents)}
                                                                                </span>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                ) : (
                                                                    <p>Нет данных</p>
                                                                )}
                                                            </div>
                                                        ))}
                                                </div>
                                            )}
                                        </div>
                                    ))
                                )}
                            </div>
                        );
                    })
                ) : (role === "Кустовой" || role === "Учебный центр") ? (
                    kpi_data.map((kpi) => {
                        const id = kpi.name;
                        return (
                            <div key={purposeId()} id={purposeId()} className={`kpi__full__conteiner ${getKpiContainerClassColor(kpi.details)}`}>
                                <div className={"kpi__full__conteiner__title"}>
                                    <h2 className={"kpi__full__conteiner__title__name"}>{kpi.name}</h2>
                                    <div className={"kpi__full__conteiner__title__wrapper__actual__date"} key={purposeId()} id={purposeId()}>
                                        <div className={`Smile__full__kpi ${getSmilesColor(kpi.details)}`}></div>
                                        <HandySvg
                                            src={arrowUpDownKpiFull}
                                            id={kpi.id}
                                            className={`kpi__full__conteiner__title__arrow rotate ${isRotated[id] ? "activefull" : ""}`}
                                            onClick={() => getId(id, kpi.id)}
                                        />
                                    </div>
                                </div>
                                <div className={`aggregated__wrapper`}>
                                    {!full[id] &&
                                        kpi.details.map((agrDetails) => (
                                            <div key={purposeId()} className={`aggregated__wrapper__item`}>
                                            <span className="kpi__full__conteiner__data__item__name aggregated__wrapper__item__name">
                                              {agrDetails.name}:
                                            </span>
                                                                        <span className={`kpi__full__conteiner__data__item__name__date ${ColorZone(agrDetails.zone)}`}>
                                              {agrDetails.value === null ? "Нет" : setValue(agrDetails.value, agrDetails.is_percents)}
                                            </span>
                                            </div>
                                        ))}
                                </div>
                                {full[id] && (
                                    expandedKpiDetails.filter((shopData) => shopData.id === kpi.id).map((shopData) => (
                                        <div key={purposeId()} className={"kpi__full__conteiner__liner"}>
                                            <h3 className={"kpi__full__conteiner__liner__shopName"}>{shopData.name}</h3>
                                            <div className="kpi__full__conteiner__data__item__is_actual">
                                                <span>Актуально:</span>
                                                <HandySvg
                                                    src={shopData.is_actual ? dataTrue : dataFalse}
                                                    className={shopData.is_actual ? "svg--data_true" : "svg--data_false"}
                                                />
                                            </div>
                                            {shopData.details.length > 0 ? (
                                                <div className="kpi__full__conteiner__data">
                                                    {shopData.details.map((detail) => (
                                                        <div key={purposeId()} className="kpi__full__conteiner__data__item">
                                                            <span className="kpi__full__conteiner__data__item__name">{detail.name}:</span>
                                                            <span className={`kpi__full__conteiner__data__item__name__date ${ColorZone(detail.zone)}`}>
                                                              {detail.value === null ? "Нет" : setValue(detail.value, detail.is_percents)}
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <p>Нет данных</p>
                                            )}
                                        </div>
                                    ))
                                )}
                            </div>
                        );
                    })
                ) : null}
                {
                    kpi_data && kpi_data.length === 0?
                        <DataUndefaind text={`Cейчас нет данных`}/> :
                        null
                }
            </div>
        );
    }
}

export default KpiFull;